/* eslint-disable */
import axios from "axios";
import { admBack, personasBack } from "../core/configs/config";
import { formatDate } from "../utils/utils";
import "../utils/axios.interceptor";
import HttpService from '../services/HttpService';
HttpService.configure();

const axiosClient = HttpService.getAxiosClient();
const epGetPersonasFisicas = "v1/personas/";
const epCreatePersonaFisica = "v1/create-persona/";
const epUpdatePersonaFisica = "v1/update-persona/";
const epGetPersonasFisicasHistorial = "v1/personas-history/";
const epGetPersonaById = "v1/persona-by-id/";
const epGetPersonaHistoryById = "v1/persona-history-by-id/";
const itemGender = "F";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//

export const getPersonasFisicas = async (params) => {
  let _params = {};
  let argentino = '';
  let _errorMessage = "Se produjo un error al obtener las Personas Fisicas";

  // Construye los parámetros 
  if (params.fechaCreacionDesde) {
    _params.fecha_creacion_desde = formatDate(params.fechaCreacionDesde);
  }
  if (params.fechaCreacionHasta) {
    _params.fecha_creacion_hasta = formatDate(params.fechaCreacionHasta);
  }
  if (params.nombre) {

    _params.nombre = params.nombre.toLowerCase();
  }
  if (params.apellido) {

    _params.apellido = params.apellido.toLowerCase();
  }
  if (params.cuil){
  
    _params.cuil = params.cuil;
  } 
  
  if (params.cuit) {

    _params.cuit = params.cuit;
  }
  if (params.numeroDocumento){
    _params.numero_documento = params.numeroDocumento;
    
  }

  if (params.sexoRegistradoNacimiento) {
    const sexo = params.sexoRegistradoNacimiento.toLowerCase();
    _params.sexo_registrado_nacimiento = sexo === "todos" ? null : sexo.charAt(0);
  }

  if (params.argentino) {
    argentino = params.argentino === "Si" ? false : true;
    _params.extranjero = argentino;
  }

  if (params.rows) {
    _params.rows = params.rows;
  }

  if (params.first) {
    _params.first = params.first;
  }

  console.log('TODO Delete');
  console.log('inside PersonaFisicaService - _params: ', _params);
  console.log('##################');

  try {
    const response = await axiosClient.get(`${personasBack}${epGetPersonasFisicas}`, {
      params: _params,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });

    if (response.status === 200 && response.data.status !== "error") {
      response.ok = true;
      return response;
    } else {
      response.ok = false;
      response.messageText = _errorMessage;
      response.messageSeverity = "error";
      return response;
    }
  } catch (error) {
    console.error("Error en la solicitud de getPersonasFisicas:", error);
    return {
      ok: false,
      messageText: _errorMessage,
      messageSeverity: "error",
    };
  }
};


export const getPersonasFisicasHistorial = async (params) => {
  let _params = {};
  let argentino = '';
  let _errorMessage = "Se produjo un error al obtener Historial de Personas Fisicas";
  const token = localStorage.getItem("Token");

  if (params.fechaCreacionDesde) {
    _params.fecha_creacion_desde = formatDate(params.fechaCreacionDesde);
  }

  if (params.fechaCreacionHasta) {
    _params.fecha_creacion_hasta = formatDate(params.fechaCreacionHasta);
  }

  if (params.nombre) {
    _params.nombre = params.nombre.toLowerCase();
  }

  if (params.apellido) {
    _params.apellido = params.apellido.toLowerCase();
  }

  if (params.cuil) {
    _params.cuil = params.cuil;
  }

  if (params.cuit) {
    _params.cuit = params.cuit;
  }

  if (params.matricula) {
    _params.matricula = params.matricula;
  }

  if (params.numeroDocumento) {
    _params.nro_documento = params.numeroDocumento;
  }

  if (params.sexoRegistradoNacimiento) {
    if (params.sexoRegistradoNacimiento === "Masculino") {
      _params.sexo_registrado_nacimiento = "m";
    }
    if (params.sexoRegistradoNacimiento === "Femenino") {
      _params.sexo_registrado_nacimiento = "f";
    }
    if (params.sexoRegistradoNacimiento === "Todos") {
      _params.sexo_registrado_nacimiento = null;
    }
  }
  if (params.argentino) {
    argentino = params.argentino
    if (argentino === "Si") {
      _params.extranjero = false
    } else if (argentino === "No") {
      _params.extranjero = true
    }
  }

  if (params.rows) {
    _params.rows = params.rows;
  }

  if (params.first) {
    _params.first = params.first;
  }

  try {
    const response = await axiosClient.get(`${personasBack}${epGetPersonasFisicasHistorial}`, {
      params: _params,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado 
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    let _message_code = response.data.code;
    // ejemplo de error controlado
    if (_message_code === "err-encontrado") {
      response.messageText = `Detallo el error `;
    } else {
      response.messageText = _errorMessage;
    }
    response.ok = false;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};



//
// #############################################################################
//
export const getPersonaById = async (idPersona) => {

  let _errorMessage = "Se produjo un error al obtener la persona";
  const token = localStorage.getItem("Token");
  let _params = {};
  _params = {
    id: idPersona
  }

  try {
    const response = await axiosClient.get(`${personasBack}${epGetPersonaById}`, {
      params: _params,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};


//
// #############################################################################
//
export const getPersonaHistoryById = async (idPersona) => {

  let _errorMessage = "Se produjo un error al obtener la persona";
  const token = localStorage.getItem("Token");
  let _params = {};
  _params = {
    id: idPersona
  }

  try {
    const response = await axiosClient.get(`${personasBack}${epGetPersonaHistoryById}`, {
      params: _params,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};

// create or update persona fisica
export const savePersonaFisica = async (actionCrud, persona) => {
  let _errorMessage = "Se produjo un error al crear la persona";
  const token = localStorage.getItem("Token");

  try {

    const response = await axiosClient.get(`${personasBack}${epGetPersonasFisicas}`, {
      params: _params,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });
    
    // let response = {};
    // if (actionCrud === "create") {
    //   response = await axios({
    //     method: "POST",
    //     url: `${personasBack}${epCreatePersonaFisica}`,
    //     data: persona,
    //     headers: {
    //       'Authorization': `Bearer ${token}`
    //     },
    //   });
    // } else if (actionCrud === "update") {
    //   response = await axios({
    //     method: "PUT",
    //     url: `${personasBack}${epUpdatePersonaFisica}`,
    //     data: persona,
    //     headers: {
    //       'Authorization': `Bearer ${token}`
    //     },
    //   });
    // }

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText =
          `${nameItemTextCaja}` +
          (actionCrud === "disable"
            ? itemGender === "M"
              ? " deshabilitado"
              : " deshabilitada"
            : actionCrud === "enable"
              ? itemGender === "M"
                ? " habilitado"
                : " habilitada"
              : itemGender === "M"
                ? " guardado"
                : " guardada");
        response.messageSeverity = "success";
      } else {
        // si hay error controlado
        console.log(_errorMessage);
        console.log(response);

        let _message_code = response.data.message_code;
        if (_message_code === "err-area-already-exist") {
          response.messageText = `Ya existe ${unUna} ${nameItemTextCaja} con esa descripción`;
        } else {
          response.messageText = _errorMessage;
        }
        response.ok = false;
        response.messageSeverity = "error";
      }
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
}
